export default "<span *ngIf=\"highlightedDisplayName\" [style.color]=\"highlightedDisplayName.color\">\n  {{ highlightedDisplayName.text }}\n</span>\n"